import k from "./index8.js";
import { resolveComponent as s, openBlock as n, createElementBlock as a, Fragment as i, createBlock as c, createElementVNode as t, renderList as d, createVNode as r, createCommentVNode as l, normalizeClass as S, withCtx as b } from "vue";
import "./index9.js";
import w from "../../../../_virtual/index.js";
const M = {
  key: 0,
  class: "navigation-container desktop"
}, N = {
  key: 1,
  class: "navigation",
  "aria-label": "primary"
}, T = { class: "menu-categories" }, C = { class: "menu-category-list" }, B = {
  key: 0,
  class: "search-container"
}, I = { class: "contracts-menu-list" }, _ = {
  key: 0,
  class: "contracts-menu-list-item"
};
function H(e, u, D, E, $, A) {
  const h = s("NavigationSkeleton"), m = s("MenuCategory"), p = s("ContractsSearch"), g = s("NavigationSkeletonMobile"), y = s("HeaderAccount"), f = s("mobile-header");
  return n(), a(i, null, [
    e.bannerStyle === e.BannerStyle.Normal ? (n(), a("div", M, [
      e.isDataUnavailable || !e.areTranslationsLoaded ? (n(), c(h, { key: 0 })) : (n(), a("nav", N, [
        t("div", T, [
          t("ul", C, [
            (n(!0), a(i, null, d(e.menuCategories, (o) => (n(), a("li", {
              class: "menu-category-list-item",
              key: o.name
            }, [
              r(m, {
                dropdownMenuItems: e.convertToDropdownItems(o),
                name: e.translateMenuCategoryName(o).desktopName,
                url: o.url,
                menuType: e.menuTypes.ExpandOnHover
              }, null, 8, ["dropdownMenuItems", "name", "url", "menuType"])
            ]))), 128))
          ])
        ]),
        e.showSearch ? (n(), a("div", B, [
          r(p, {
            hasSearchIcon: !1,
            hasSearchButton: !0,
            placeholder: e.t("header.search-this-site"),
            config: e.config
          }, null, 8, ["placeholder", "config"])
        ])) : l("", !0)
      ]))
    ])) : l("", !0),
    t("div", {
      class: S(["navigation-container-mobile", e.isSelectionPageBanner ? "selection-page" : "not-selection-page"])
    }, [
      e.showMenu ? (n(), a("div", {
        key: 0,
        class: "overlay",
        onClick: u[0] || (u[0] = (...o) => e.closeMenu && e.closeMenu(...o))
      })) : l("", !0),
      e.isDataUnavailable || !e.areTranslationsLoaded ? (n(), c(g, { key: 1 })) : (n(), c(f, {
        key: 2,
        "show-search": e.config.showSearch !== !1 && !e.isSelectionPageBanner,
        config: e.config,
        "show-hamburger-menu": !e.isSelectionPageBanner,
        bannerStyle: e.bannerStyle
      }, {
        default: b(() => [
          t("ul", I, [
            e.config.showAccountMenu !== !1 ? (n(), a("li", _, [
              r(y, {
                isMobile: !0,
                user: e.user,
                config: e.config
              }, null, 8, ["user", "config"])
            ])) : l("", !0),
            (n(!0), a(i, null, d(e.menuCategories, (o, v) => (n(), a("li", {
              class: "contracts-menu-list-item",
              key: o.name
            }, [
              r(m, {
                dropdownMenuItems: e.convertToDropdownItems(o),
                name: e.translateMenuCategoryName(o).mobileName,
                url: o.url,
                menuType: e.menuTypes.ExpandOnClick,
                class: "menu-category-mobile",
                shouldHighlight: v === e.menuCategories.length - 1
              }, null, 8, ["dropdownMenuItems", "name", "url", "menuType", "shouldHighlight"])
            ]))), 128))
          ])
        ]),
        _: 1
      }, 8, ["show-search", "config", "show-hamburger-menu", "bannerStyle"]))
    ], 2)
  ], 64);
}
const U = /* @__PURE__ */ w(k, [["render", H], ["__scopeId", "data-v-97aa7985"]]);
export {
  U as default
};
//# sourceMappingURL=index5.js.map
